<template>
  <nuttrema-layout-content>
    <template slot="header">
      <instance-standard-header
        :edit.sync="edit"
        :showEdit="false"
        :meta="meta"
        :InstanceDetails="InstanceDetails">
        <div slot="right" class="content-header-item">
          <el-dropdown @command="handleCommand">
            <el-button type="text">
              {{ $t('label.options') }} <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="upgradePlan">{{ $t('label.upgrade_plan') }}</el-dropdown-item>
              <el-dropdown-item command="showHelp" divided>{{ $t('label.help') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </instance-standard-header>
      <nuttrema-layout-content-header v-if="edit" theme="registration-steps">
        <el-steps :active="activeStep" finish-status="success" simple>
          <el-step title="Upgrade plan"></el-step>
          <el-step title="Confirm and pay" ></el-step>
          <el-step title="Finish" ></el-step>
        </el-steps>
      </nuttrema-layout-content-header>
    </template>

    <template slot="central">
      <nuttrema-loader v-if="InstanceDetails.fetching"></nuttrema-loader>
      <template v-else>
        <!-- <form-settings-subscription class="is-no-bg" :edit="edit"></form-settings-subscription> -->
        <form-settings-checkout
           class="is-no-bg"
          :edit.sync="edit"
          :InstanceDetails="InstanceDetails">
        </form-settings-checkout>
      </template>
    </template>

  </nuttrema-layout-content>
</template>

<script>
import PageProps from 'components/mixins/page-props';
import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';

import InstanceStandardHeader from 'components/pages/professional/instance/shared/cmpt-instance-standard-header';
import NuttremaLayoutContentHeader from 'components/ui/layout/nuttrema-layout-content-header';

import FormSettingsSubscription from './form-settings-subscription';
import FormSettingsCheckout from './form-settings-checkout';

export default {
  name: 'page-settings-subscription',
  mixins: [PageProps],
  components: {
    FormSettingsCheckout,
    NuttremaLayoutContent,
    InstanceStandardHeader,
    FormSettingsSubscription,
    NuttremaLayoutContentHeader,
  },
  data() {
    return {
      edit: false,
      activeStep: 1,
    };
  },
  computed: {
    InstanceDetails() {
      return this.$store.getters.InstanceDetails;
    },
  },
  methods: {
    onDeleteEvent() {},
    onFormSubmitEvent() {},
    handleCommand(command) {
      console.log('handleCommand', command);
      switch (command) {
        case 'showHelp':
          this.showHelp = true;
          break;
        case 'upgradePlan':
          this.edit = true;
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .subscription-upgrade-steps {
    padding: 2em;
    display: flex;
    flex-shrink: 0;
    background-color: #fff;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/instance/subscription/page-settings-subscription.vue